import React, { useMemo } from "react";
import DocumentCard from "components/card/DocumentCard";
import { TrendingUp } from "lucide-react";
import NoDocument from "./NoDocument";

const PromotionsDocument = ({ documents = [] }) => {
    const promotionDocs = useMemo(() => {
        return documents?.filter(doc => 
            doc?.doc_type_name === 'Promotion'
        );
    }, [documents]);

    if (promotionDocs.length === 0) {
        return (
             <>
                <NoDocument docType="Promotion"/>
            </>
        );
    }

    return (
        <div className="space-y-3">
            {promotionDocs.map((doc, index) => (
                <DocumentCard
                    key={doc.doc_id}
                    title={doc.doc_title}
                    description={doc.doc_description}
                    status={doc.doc_status_name}
                    date={doc.doc_date}
                    size={doc.doc_size}
                    icon={<TrendingUp className="w-5 h-5 text-purple-600" />}
                    documentData={doc}
                    onDownload={() => console.log(`Download ${doc.title}`)}
                />
            ))}
        </div>
    );
};

export default PromotionsDocument;
